import styled from 'styled-components';
import { setColor, setRem } from '../../utils/styles';
import { motion } from 'framer-motion';

export const PageWrapper = styled(motion.div)`
  position: relative;
  height: calc(100vh - ${setRem(130)});
  overflow: hidden;

  ${({ borderTop }) =>
    borderTop &&
    `
    border-top: ${setRem(2)} solid ${setColor.primaryColor};
  `}

  ${({ paddingBottom }) =>
    paddingBottom &&
    `
    padding-bottom: ${setRem(50)};
  `}

  ${({ background }) =>
    background &&
    `
    background: linear-gradient(to bottom, ${setColor.whiteColor} 0 50%, ${setColor.primaryColor} 50% 100%);
  `}
`;
